export enum AMSCall {
  getAllMessages,
  getSummary,
  getMessage,
  deleteMessages,
  markAllAsRead,
  markAsRead,
  markAsReadByMetadata,
  notifyUnreadCount,
  getUnreadMessageCount,
}

export type AMSCallName = keyof typeof AMSCall
